module.exports = __webpack_public_path__ + "img/DW365-170.77241735.jpg";